/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
const TreeNode = require('../TreeNode');
const UseAbility = require('../UseAbility');
const BattleCalc = require('../../BattleCalc');
const AICalc = require('../AICalc');
const Q_target_high_hp = require('./Q_target_high_hp');

const Q_which_aoe = function (actor, battleState) {
  const node = new TreeNode(actor, battleState);

  // branch indexes
  node.MULTI_SHOT = 'multi_shot';
  node.MOLOTOV = 'molotov_cocktail';
  node.FUMIGATE = 'fumigate';
  node.LIGHTNING = 'lightning';
  node.NO_RANGED_AOE_ABILITIES = 'no_ranged_aoe_abilities';

  node.multiShot = BattleCalc.getEquippedAbility(actor, 'multi_shot');
  node.molotov = BattleCalc.getEquippedAbility(actor, 'molotov_cocktail');
  node.fumigate = BattleCalc.getEquippedAbility(actor, 'fumigate');
  node.lightning = BattleCalc.getEquippedAbility(actor, 'lightning');
  node.DAMAGE_DICT = {
    multi_shot: node.multiShot ? node.multiShot.damage : 0,
    fumigate: node.fumigate ? node.fumigate.potency : 0,
    lightning: node.lightning ? node.lightning.damage : 0,
    molotov_cocktail: node.molotov ? node.molotov.damage : 0,
  };

  const altNode = new Q_target_high_hp(actor, battleState);

  node.branches[node.MULTI_SHOT] = node.multiShot ? new UseAbility(actor, 'multi_shot') : altNode;
  node.branches[node.MOLOTOV] = node.molotov ? new UseAbility(actor, 'molotov_cocktail') : altNode;
  node.branches[node.FUMIGATE] = node.fumigate ? new UseAbility(actor, 'fumigate') : altNode;
  node.branches[node.LIGHTNING] = node.lightning ? new UseAbility(actor, 'lightning') : altNode;
  node.branches[node.NO_RANGED_AOE_ABILITIES] = altNode;

  const originalDispose = node.dispose;
  node.dispose = function() {
    node.multiShot = null;
    node.molotov = null;
    node.fumigate = null;
    node.lightning = null;
    node.DAMAGE_DICT = null;
    originalDispose.call(node);
  };

  node.query = function (target) {
    const equipped_ranged_aoe_abilities = [
      'multi_shot',
      'molotov_cocktail',
      'fumigate',
      'lightning',
    ].filter((ability_handle) => {
      const ability = BattleCalc.getEquippedAbility(node.actor, ability_handle);
      if (!ability) {
        return false;
      }

      // Use generic damage prediction to check if AoE is beneficial
      // For multi_shot, always allow it (only hits enemies)
      if (ability_handle === 'multi_shot') {
        return true;
      }
      // For other AoE abilities, check damage prediction
      // Target is the actor for self-centered AoE (fumigate) or the provided target
      const abilityTarget = ability_handle === 'fumigate' ? node.actor : target;
      return AICalc.isAoESafe(
        node.actor,
        ability_handle,
        abilityTarget,
        node.battleState,
        1.5 // Enemy damage must be 50% more than ally damage
      );
    });
    if (equipped_ranged_aoe_abilities.length) {
      const random_ranged_aoe_ability =
        equipped_ranged_aoe_abilities[
          Math.floor(Math.random() * equipped_ranged_aoe_abilities.length)
        ];
      return node.branches[random_ranged_aoe_ability].query(
        random_ranged_aoe_ability === 'fumigate' ? node.actor : target
      );
    } else {
      return node.branches[node.NO_RANGED_AOE_ABILITIES].query(target);
    }
  };

  return node;
};
module.exports = Q_which_aoe;
